module.exports = __webpack_public_path__ + "img/idx-title-02.9020b1a.webp";